module.exports = __webpack_public_path__ + "img/low.55235238.png";